import { degreesToRadians, measureAngle } from "./angle.js";

const basic = {
  degreesToRadians,
  measureAngle
};

export default basic;
